import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton, FadeIn } from './Shared';
export const Hero = () => {
  return <section className="relative pt-16 pb-10 md:pt-28 md:pb-20 overflow-hidden bg-cream" data-id="element-76">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-77">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-sage-100/50 blur-3xl" data-id="element-78" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-sage-50 blur-3xl" data-id="element-79" />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-8 text-center" data-id="element-80">
        <FadeIn data-id="element-81">
          <div className="inline-flex items-center space-x-2 bg-white px-4 py-2 rounded-full shadow-sm mb-6 border border-sage-100" data-id="element-82">
            <div className="flex text-yellow-400" data-id="element-83">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-84" />)}
            </div>
            <span className="text-sm font-medium text-slate-600" data-id="element-85">
              4.9/5 Elegido por mujeres
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-86">
          <h1 className="md:text-6xl lg:text-7xl text-sage-900 mb-5 md:mb-8 tracking-tight text-[24px] font-[700]" data-id="element-87">
            NO ES GRASA, ES HINCHAZON Y PODES ELIMINARLA
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} className="relative z-10 mb-8" data-id="element-88">
          <motion.img initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} src="https://cdn.magicpatterns.com/uploads/1sowwNckLqZTceKRf5S4aL/Deshinchate_mockup.png" alt="Deshinchate Book and Worksheets Mockup" className="w-[80%] max-w-lg mx-auto drop-shadow-2xl" data-id="element-89" />
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-90">
          <p className="text-lg md:text-xl text-slate-600 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-91">
            El sistema práctico para eliminar la hinchazón silenciosa, recuperar
            tu energía y volver a sentirte liviana sin dietas extremas ni
            soluciones temporales.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-92">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-93">
            <CTAButton data-id="element-94">Acceder a Deshinchate ahora</CTAButton>
            <span className="text-sm text-slate-500 italic" data-id="element-95">
              Acceso inmediato
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};